import { TFunction } from 'i18next'
import BGTaskScheduleRestService from '../rest/BGTaskScheduleRestService'

class BGTaskScheduleService {


    static get() {
        return BGTaskScheduleRestService.get()
    }

    static async getSchedules(setSchedules: Function) {
        const schedules: [] = await BGTaskScheduleRestService.get()
        setSchedules(schedules)
        return schedules
    }

    static getByID(id: number) {
        return BGTaskScheduleRestService.getById(id)
    }

    static getDefinitions() {
        return BGTaskScheduleRestService.getDefinitions()
    }

    static getDefinitionByType(type: string) {
        return BGTaskScheduleRestService.getDefinitionByType(type)
    }

    static getRecentBGTasksOfSchedule(scheduleId: number, limit: number) {
        return BGTaskScheduleRestService.getRecentBGTasksOfSchedule(scheduleId, limit)
    }

    static async createSchedule(schedule: any, t: TFunction, setSchedules: Function) {
        try {
            const editedSchedule = await BGTaskScheduleRestService.create(schedule)
            await BGTaskScheduleService.getSchedules(setSchedules)
            return t('bgTaskSchedule.createSuccess', { name: editedSchedule.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async updateSchedule(schedule: any, setSchedule: Function, t: TFunction) {
        try {
            const editedSchedule = await BGTaskScheduleRestService.update(schedule)
            await BGTaskScheduleService.getSchedules(setSchedule)
            return t('bgTaskSchedule.editSuccess', { name: editedSchedule.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async deleteSchedule(schedule: any, t: TFunction, setSchedules: Function) {
        try {
            await BGTaskScheduleRestService.delete(schedule.id)
            await BGTaskScheduleService.getSchedules(setSchedules)
            return t('bgTaskSchedule.deleteSuccess', { name: schedule.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async createScheduleConfig(schedule: any, t: TFunction, setBGTaskFieldConfigs: Function) {
        try {
            const editedSchedule = await BGTaskScheduleRestService.createConfig(schedule)
            await BGTaskScheduleService.getAllFieldConfigs(setBGTaskFieldConfigs)
            return t('bgTaskSchedule.createSuccess', { name: editedSchedule.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async updateScheduleConfig(schedule: any, t: TFunction, setBGTaskFieldConfigs: Function) {
        try {
            const editedSchedule = await BGTaskScheduleRestService.updateConfig(schedule)
            await BGTaskScheduleService.getAllFieldConfigs(setBGTaskFieldConfigs)
            return t('bgTaskSchedule.editSuccess', { name: editedSchedule.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async deleteScheduleConfig(schedule: any, t: TFunction, setBGTaskFieldConfigs: Function) {
        try {
            await BGTaskScheduleRestService.deleteConfig(schedule.id)
            await BGTaskScheduleService.getAllFieldConfigs(setBGTaskFieldConfigs)
            return t('bgTaskSchedule.deleteSuccess', { name: schedule.name })
        } catch (error) {
            return Promise.reject(error)
        }
    }

    static async getAllFieldConfigs(setBGTaskFieldConfigs: Function) {
        try {
            const configs = await BGTaskScheduleRestService.getAllFieldConfigs()
            setBGTaskFieldConfigs(configs)
            return configs
        } catch (error) {
            return Promise.reject(error)
        }
    }
}


export default BGTaskScheduleService
